import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../providers/AuthContext";

export default function MatrimonyForm() {
  const [formData, setFormData] = useState({});
  const [photos, setPhotos] = useState([]);
  const [dragActive, setDragActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();
  const [profileSubmitted, setprofileSubmitted] = useState(false);

  const [managerData, setManagerData] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}managers?status=active`, {credentials: "include"})
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setManagerData(data.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const totalFiles = photos.length + files.length;

    if (totalFiles > 3) {
      alert("You can upload a maximum of 3 photos.");
      const allowedFiles = files.slice(0, 3 - photos.length);
      setPhotos([...photos, ...allowedFiles]);
    } else {
      setPhotos([...photos, ...files]);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const files = Array.from(e.dataTransfer.files);
      const totalFiles = photos.length + files.length;

      if (totalFiles > 3) {
        alert("You can upload a maximum of 3 photos.");
        const allowedFiles = files.slice(0, 3 - photos.length);
        setPhotos([...photos, ...allowedFiles]);
      } else {
        setPhotos([...photos, ...files]);
      }
    }
  };

  const removePhoto = (index) => {
    setPhotos(photos.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const data = new FormData();
    for (const key in formData) {
      data.append(key, formData[key]);
    }

     if (user.role === "manager") {
      data.append('manager',user.id);
    }

    photos.forEach((file) => {
      data.append("photos", file);
    });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}profiles`,
        {
          method: "POST",
          credentials: "include",
          body: data
        }
      );

      const result = await response.json();
      console.log(result);
      alert(result.message || "Profile submitted!");
      if (user) {
        navigate(process.env.PUBLIC_URL + "/");
      } else {
        setprofileSubmitted(true);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Something went wrong!");
    }

    setLoading(false);
  };

  return (
    <div className="container mt-5">
      {profileSubmitted ? (
        <div className="container d-flex align-items-center justify-content-center min-vh-100 bg-light">
          <div
            className="card shadow p-5 text-center"
            style={{ maxWidth: "500px" }}
          >
            <div className="mb-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-success bg-opacity-10 rounded-circle"
                style={{ width: "100px", height: "100px" }}
              >
                <i
                  className="fa fa-check-circle text-success"
                  aria-hidden="true"
                  style={{ fontSize: "6.5rem" }}
                ></i>
              </div>
            </div>

            <h2 className="h4 fw-bold">Submitted Successfully</h2>
            <p className="text-muted mt-3 mb-0">
              Thank you — your submission has been received successfully.
            </p>
          </div>
        </div>
      ) : (
        <div className="card shadow p-4">
          <h2 className="mb-4 text-center">Data Sheet</h2>
          <form onSubmit={handleSubmit}>
            {(!user || user.role !== "manager") && (
              <>
                <h4 className="mb-3">Manager Details</h4>
                <div className="row g-3 b-3">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Select Manager</label>
                    <select
                      className="form-select form-control"
                      name="manager"
                      onChange={handleChange}
                    >
                      <option value="">Select Manager</option>
                      {managerData.length > 0 &&
                        managerData.map((manager, index) => (
                          <option value={manager._id} key={index}>
                            {manager.name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </>
            )}
            {/* Personal Details */}
            <h4 className="mb-3">Personal Details</h4>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label">Name with surname</label>
                <input
                  className="form-control"
                  name="name"
                  required
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Date of Birth</label>
                <input
                  type="date"
                  className="form-control"
                  name="dob"
                  max={new Date().toISOString().split("T")[0]}
                  required
                  onChange={handleChange}
                />
              </div>
              {/* <div className="col-md-6">
                <label className="form-label">Age</label>
                <input
                  type="number"
                  className="form-control"
                  name="age"
                  required
                  onChange={handleChange}
                />
              </div> */}
              <div className="col-md-6">
                <label className="form-label">Gender</label>
                <select
                  name="gender"
                  className="form-control"
                  required
                  onChange={handleChange}
                >
                  <option value="">-- Select Gender --</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label">Birth Nakshatram</label>
                <select
                  name="nakshatram"
                  className="form-control"
                  required
                  onChange={handleChange}
                >
                  <option value="">-- Select Nakshatra --</option>
                  <option value="Ashwini">Ashwini</option>
                  <option value="Bharani">Bharani</option>
                  <option value="Krittika">Krittika</option>
                  <option value="Rohini">Rohini</option>
                  <option value="Mrigashira">Mrigashira</option>
                  <option value="Ardra">Ardra</option>
                  <option value="Punarvasu">Punarvasu</option>
                  <option value="Pushya">Pushya</option>
                  <option value="Ashlesha">Ashlesha</option>
                  <option value="Magha">Magha</option>
                  <option value="Purva Phalguni">Purva Phalguni</option>
                  <option value="Uttara Phalguni">Uttara Phalguni</option>
                  <option value="Hasta">Hasta</option>
                  <option value="Chitra">Chitra</option>
                  <option value="Swati">Swati</option>
                  <option value="Vishakha">Vishakha</option>
                  <option value="Anuradha">Anuradha</option>
                  <option value="Jyeshtha">Jyeshtha</option>
                  <option value="Mula">Mula</option>
                  <option value="Purva Ashadha">Purva Ashadha</option>
                  <option value="Uttara Ashadha">Uttara Ashadha</option>
                  <option value="Shravana">Shravana</option>
                  <option value="Dhanishta">Dhanishta</option>
                  <option value="Shatabhisha">Shatabhisha</option>
                  <option value="Purva Bhadrapada">Purva Bhadrapada</option>
                  <option value="Uttara Bhadrapada">Uttara Bhadrapada</option>
                  <option value="Revati">Revati</option>
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label">Padam</label>
                <select
                  name="padam"
                  className="form-control"
                  required
                  onChange={handleChange}
                >
                  <option value="">-- Select Padam --</option>
                  <option value="1st Padam">1st Padam</option>
                  <option value="2nd Padam">2nd Padam</option>
                  <option value="3rd Padam">3rd Padam</option>
                  <option value="4th Padam">4th Padam</option>
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label">Birth Rasi</label>
                <select
                  name="rasi"
                  className="form-control"
                  required
                  onChange={handleChange}
                >
                  <option value="">-- Select Rasi --</option>
                  <option value="Mesha">Mesha</option>
                  <option value="Vrishabha">Vrishabha</option>
                  <option value="Mithuna">Mithuna</option>
                  <option value="Karkataka">Karkataka</option>
                  <option value="Simha">Simha</option>
                  <option value="Kanya">Kanya</option>
                  <option value="Tula">Tula</option>
                  <option value="Vrishchika">Vrishchika</option>
                  <option value="Dhanu">Dhanu</option>
                  <option value="Makara">Makara</option>
                  <option value="Kumbha">Kumbha</option>
                  <option value="Meena">Meena</option>
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label">Time of Birth</label>
                <input
                  type="time"
                  className="form-control"
                  name="tob"
                  required
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Place of Birth</label>
                <input
                  className="form-control"
                  name="pob"
                  required
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Height (in feet)</label>
                <input
                  className="form-control"
                  name="height"
                  required
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Complexion</label>
                <select
                  className="form-select form-control"
                  name="complexion"
                  required
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="Fair">Fair</option>
                  <option value="Medium">Medium</option>
                  <option value="Dark">Dark</option>
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label">Education</label>
                <input
                  className="form-control"
                  name="education"
                  required
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">College Studied</label>
                <input
                  className="form-control"
                  name="college"
                  required
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Job</label>
                <select
                  className="form-select form-control"
                  name="jobType"
                  required
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="Software">Software</option>
                  <option value="Bank">Bank</option>
                  <option value="Govt. Job">Govt. Job</option>
                  <option value="Private Corporate">Private Corporate</option>
                  <option value="Doctor">Doctor</option>
                  <option value="Others">Others</option>
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label">Job Role</label>
                <input
                  className="form-control"
                  name="jobRole"
                  required
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Company Name</label>
                <input
                  className="form-control"
                  name="company"
                  required
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Salary per annum (LPA)</label>
                <input
                  type="number"
                  className="form-control"
                  name="salary"
                  step={0.01}
                  max={100}
                  required
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Place of Work</label>
                <input
                  className="form-control"
                  name="workPlace"
                  required
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">
                  Wanted partner from any specific field?
                </label>
                <input
                  className="form-control"
                  name="partnerPreference"
                  required
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Family Details */}
            <h4 className="mt-5 mb-3">Family Details</h4>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label">Father Name</label>
                <input
                  className="form-control"
                  name="fatherName"
                  required
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Father Job</label>
                <input
                  className="form-control"
                  name="fatherJob"
                  required
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Mother Name</label>
                <input
                  className="form-control"
                  name="motherName"
                  required
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Mother Job</label>
                <input
                  className="form-control"
                  name="motherJob"
                  required
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Sibling 1</label>
                <input
                  className="form-control"
                  name="sibling1"
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Sibling 1 Job</label>
                <input
                  className="form-control"
                  name="siblingJob1"
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Sibling 2</label>
                <input
                  className="form-control"
                  name="sibling2"
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Sibling 2 Job</label>
                <input
                  className="form-control"
                  name="siblingJob2"
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Sibling 3</label>
                <input
                  className="form-control"
                  name="sibling3"
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Sibling 3 Job</label>
                <input
                  className="form-control"
                  name="siblingJob3"
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Sibling 4</label>
                <input
                  className="form-control"
                  name="sibling4"
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Sibling 4 Job</label>
                <input
                  className="form-control"
                  name="siblingJob4"
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Caste</label>
                <input
                  className="form-control"
                  name="caste"
                  value="Velama"
                  required
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Sub Caste</label>
                <select
                  name="subCaste"
                  className="form-control"
                  required
                  onChange={handleChange}
                >
                  <option value="">-- Select Sub Caste --</option>
                  <option value="Polinati Velama">Polinati Velama</option>
                  <option value="Koppula Velama">Koppula Velama</option>
                  <option value="Adi Velama">Adi Velama</option>
                  <option value="Padmanayaka Velama">Padmanayaka Velama</option>
                  <option value="Other Velama">Other Velama</option>
                </select>
              </div>
              <div className="col-md-12">
                <label className="form-label">Present Family Address</label>
                <textarea
                  className="form-control"
                  name="address"
                  required
                  onChange={handleChange}
                ></textarea>
              </div>
              <div className="col-md-6">
                <label className="form-label">Native Place</label>
                <input
                  className="form-control"
                  name="nativePlace"
                  required
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Contact Numbers</label>
                <input
                  className="form-control"
                  name="contact"
                  minLength="10"
                  maxLength="10"
                  required
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Photo Upload */}
            <h4 className="mt-5 mb-3">Upload Photos</h4>
            <div
              className={`border border-2 p-4 text-center rounded ${
                dragActive ? "border-primary bg-light" : "border-secondary"
              }`}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
            >
              <input
                type="file"
                accept="image/*"
                multiple
                onChange={handleFileChange}
                className="form-control d-none"
                id="photoUpload"
                disabled={photos.length >= 3}
              />
              <label
                htmlFor="photoUpload"
                style={{
                  cursor: photos.length >= 3 ? "not-allowed" : "pointer",
                }}
              >
                {photos.length > 0 ? (
                  <div className="row g-3">
                    {photos.map((file, index) => (
                      <div
                        key={index}
                        className="col-md-4 text-center position-relative"
                      >
                        <button
                          type="button"
                          className="btn-close position-absolute top-0 end-0 m-1"
                          aria-label="Remove"
                          onClick={() => removePhoto(index)}
                        ></button>
                        <p
                          className="mb-1 small text-truncate"
                          title={file.name}
                        >
                          {file.name}
                        </p>
                        <img
                          src={URL.createObjectURL(file)}
                          alt="preview"
                          className="img-fluid rounded border"
                          style={{ maxHeight: "150px" }}
                        />
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="mb-0">
                    Drag & Drop photos here or click to upload{" "}
                    <small>(Max 3 Photos)</small>
                  </p>
                )}
              </label>
            </div>

            <button
              type="submit"
              className="btn btn-primary w-100 mt-4"
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </form>
        </div>
      )}
    </div>
  );
}
